import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import PageHeader from "../../components/PageHeader/PageHeader";
import { getRegion } from "../../redux/actions/region.action";
import { getPaymentTerm } from "../../redux/actions/paymentterm.action";
import { getGender } from "../../redux/actions/gender.action";
import { Row as Brow, Col as Bcol } from "reactstrap";
import {
    Button,
    Form,
    Input,
    Select,
    DatePicker,
    Table,
    InputNumber,
    Space, Spin, Modal
} from "antd";
import moment from "moment";
import { ReadCookie } from "../../utils/readCookie";
import { loadSalePerson } from "../../redux/actions/salePerson/salePersonForm.action";
import numeral from "numeral";
import { CSVLink } from "react-csv";
import { TabTitle } from "../../utils/GeneralFunction";
import { createCCOrderProcessing, getCCOrderProcessing } from "../../redux/actions/ccOrderProcessing.action";
import { getOneSalesOrderLineCC } from "../../redux/actions/saleOrderLine.action";
import Swal from "sweetalert2";
import { currencySymbol } from "../../utils/constants";

const { Option } = Select;

const CCOrderProcessing = () => {
    TabTitle("CC Order Processing")
    const [form] = Form.useForm();
    const [minimize, setMinimize] = useState(false);
    const dispatch = useDispatch();
    const menuId = ReadCookie("menuId");
    const userName = ReadCookie("name");
    const token = ReadCookie("token");
    const [orderProcessingList, setOrderProcessingList] = useState([]);
    const [loading, setLoading] = useState(false);
    const tableRef = useRef(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [orderItems, setOrderItems] = useState([]);

    const {
        gender,
        region,
        salePersonForm,
        paymentterm,
        ccOrderProcessing,
        saleOrderLine
    } = useSelector((state) => state);
    const [excelData, setExcelData] = useState([])

    useEffect(() => {
        dispatch(getRegion(token, menuId));
        dispatch(getGender(token, menuId));
        dispatch(getPaymentTerm(token, menuId));
        dispatch(loadSalePerson(token));
        dispatch(getPaymentTerm(token));
    }, [dispatch, menuId, token]);

    function downloadExcelFileData(data) {
        setExcelData(
            data.map((v) => {
                return {
                    "Order": v.order_header_no,
                    "Customer": v.billingcustomer,
                    "PO #": v.reference_no,
                    "Order Date": moment(v.order_date).format("MM-DD-YY"),
                    "Start Date": moment(v.start_date).format("MM-DD-YY"),
                    "Cancel Date": moment(v.cancel_date).format("MM-DD-YY"),
                    "CIT": v.factor_decision,
                    "Total Quantity": parseFloat(v.totalqty).toFixed(0),
                    "Pending Quantity": parseFloat(v.pendingqty).toFixed(0),
                    "Actual Committed": parseFloat(v.quantity_committed).toFixed(0),
                    "Backorder": parseFloat(v.quantity_backorder).toFixed(0),
                    "Order Amount": numeral(v.amount).format("0,0.00"),
                    "Payment Term": v.payment_term,
                    "Hold Status": v.status,
                    "Department": v.gender_name,
                    "Region": v.region_name,
                    "Sale Person Name": v.salesperson_name,
                    "Status": v.order_status,
                    "Notes": v.remarks,
                    "Subsidiary": v.company_name,
                };
            })
        )
    }

    const columns = [
        {
            title: '#',
            dataIndex: 'index',
            key: 'index',
            width: 50,
            render: (text, record, index) => {
                return index + 1;
            },
        },
        {
            title: 'Order #',
            dataIndex: 'order_header_no',
            key: 'order_header_no',
            width: 80,
            render: (text, record) => (
                <a
                    href={`
                ${"sale order" ? `sale-order?mode=edit&order_id=${record.order_header_id}&customer_id=${record.customer_id}`
                            : ``
                        } 
                
                `}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    {text}
                </a>
            ),
        },
        {
            title: 'Customer',
            dataIndex: 'billingcustomer',
            key: 'billingcustomer',
            width: 190
        },
        {
            title: 'PO #',
            dataIndex: 'reference_no',
            key: 'reference_no',
            width: 120
        },
        {
            title: 'Order Date',
            render: (text, record) => {
                return <>{moment(record.order_date).format("MM-DD-YYYY")}</>;
            },
            width: 90
        },
        {
            title: 'Start Date',
            render: (text, record) => {
                return <>{moment(record.start_date).format("MM-DD-YYYY")}</>;
            },
            width: 90
        },
        {
            title: 'Cancel Date',
            render: (text, record) => {
                return <>{moment(record.cancel_date).format("MM-DD-YYYY")}</>;
            },
            width: 90
        },
        {
            title: 'CIT',
            dataIndex: 'factor_decision',
            key: 'factor_decision',
            width: 50
        },
        {
            title: 'Total Quantity',
            render: (text, record) => {
                return <>{parseFloat(record.totalqty).toFixed(0)}</>;
            },
            width: 90,
            align: "right",
        },
        {
            title: 'Pending Quantity',
            render: (text, record) => {
                return <>{parseFloat(record.pendingqty).toFixed(0)}</>;
            },
            width: 90,
            align: "right",
        },
        {
            title: 'Actual Committed',
            render: (text, record) => {
                return <>{parseFloat(record.quantity_committed).toFixed(0)}</>;
            },
            width: 110,
            align: "right",
        },
        {
            title: 'Backorder',
            render: (text, record) => {
                return <>{parseFloat(record.quantity_backorder).toFixed(0)}</>;
            },
            width: 80,
            align: "right",
        },
        {
            title: 'Order Amount',
            dataIndex: 'amount',
            key: 'amount',
            width: 100,
            align: "right",
            render: (text, record) => {
                return <>{currencySymbol} {numeral(record.amount).format("0,00")}</>
            },
        },
        {
            title: 'Payment Term',
            dataIndex: 'payment_term',
            key: 'payment_term',
            width: 100
        },
        {
            title: 'Hold Status',
            dataIndex: 'status',
            key: 'status',
            width: 80
        },
        {
            title: 'Department',
            dataIndex: 'gender_name',
            key: 'gender_name',
            width: 85
        },
        {
            title: 'Region',
            dataIndex: 'region_name',
            key: 'region_name',
            width: 150
        },
        {
            title: 'Sale Person Name',
            dataIndex: 'salesperson_name',
            key: 'salesperson_name',
            width: 150
        },
        {
            title: 'Status',
            dataIndex: 'order_status',
            key: 'order_status',
            width: 50
        },
        {
            title: 'Notes',
            dataIndex: 'remarks',
            key: 'remarks',
            width: 50
        },
        {
            title: 'Subsidiary',
            dataIndex: 'company_name',
            key: 'company_name',
            width: 150
        },
        {
            title: 'Detail',
            dataIndex: '',
            key: '',
            align: "right",
            render: (text, record) => {
                return record.quantity_committed === 0 ? "" : record.quantity_committed > 0 && record.totalqty !== record.quantity_committed ? <a
                    style={{ border: "1px solid black", padding: 6 }}
                    href={`/order-shipment?mode=add&order_id=${record.order_header_id}`}
                    target="_blank"
                    rel="noopener noreferrer"
                >Partial Fulfillment</a> : record.quantity_committed > 0 && record.totalqty === record.quantity_committed ? <a
                    style={{ border: "1px solid black", padding: 6 }}
                    href={`/order-shipment?mode=add&order_id=${record.order_header_id}`}
                    target="_blank"
                    rel="noopener noreferrer"
                >Fulfillment</a> : ""
            },
        },
        {
            title: 'Detail',
            dataIndex: '',
            key: '',
            width: 100,
            align: "right",
            render: (text, record) => {
                return record.quantity_backorder > 0 && <Button onClick={() => {
                    showModal()
                    dispatch(getOneSalesOrderLineCC(token, record.order_header_id)).then((res) => {
                        if (res.type === "GET_ONE_SALESORDERLINECC_SUCCESS") {
                            setOrderItems(res.payload.data);
                        }
                    });
                }}>Detail</Button>
            },
        },
    ];

    const SOColumns2 = [
        {
            title: "SKU",
            dataIndex: "item_code",
            width: 100,
            fixed: 'left',
        },
        {
            title: "Style",
            dataIndex: "style_name",
            width: 120,
        },
        {
            title: "Wash",
            dataIndex: "wash_name",
            width: 140,
        },
        {
            title: "Gender Category",
            dataIndex: "gender_category_name",
            width: 120,
        },
        {
            title: "Committed",
            editable: false,
            width: 80,
            render: (text, record) => {
                return <>{record.quantity_committed}</>;
            },
        },
        {
            title: "BackOrder",
            width: 80,
            editable: false,
            render: (text, record) => {
                return (
                    <>
                        {record.quantity_backorder}
                    </>
                );
            },
        },
        {
            title: "Bergen WS",
            dataIndex: "bergen_ws_qty",
            width: 80,
            editable: true,
            render: (text, record, index) => {
                return <>
                    {record.bergen_ws_qty}
                </>;
            },
        },
        {
            title: "Bergen Ecom",
            dataIndex: "bergen_ecom_qty",
            width: 80,
            editable: true,
            render: (text, record, index) => {
                return <>
                    {record.bergen_ecom_qty}
                </>;
            },
        },
        {
            title: "Bergen Nord",
            dataIndex: "bergen_nord_qty",
            width: 80,
            editable: true,
            render: (text, record, index) => {
                return <>
                    {record.bergen_nord_qty}
                </>;
            },
        },
        {
            title: "Bergen Saks",
            dataIndex: "bergen_saks_qty",
            width: 80,
            editable: true,
            render: (text, record, index) => {
                return <>
                    {record.bergen_saks_qty}
                </>;
            },
        },
        {
            title: "Bergen WS",
            dataIndex: "bergen_ws_qty",
            width: 80,
            editable: true,
            render: (text, record, index) => {
                return <>
                    <Input
                        value={record.input_bergen_ws_qty || 0}
                        type="number"
                        onChange={(e) => {
                            let value = Number(e.target.value);
                            let copyArr = [...orderItems];
                            let sum_of_bergans = value + Number(record.input_bergen_ecom_qty || 0) + Number(record.input_bergen_saks_qty || 0) + Number(record.input_bergen_nord_qty || 0);
                            let filterItem = copyArr.filter((v) => {
                                if (v.order_lines_id === record.order_lines_id) {
                                    if (value < 0) {
                                        Swal.fire({
                                            icon: "error",
                                            title: `OOPS`,
                                            text: "Bergan WS QTY can't be Negative",
                                        })
                                    } else if (value <= record.bergen_ws_qty) {
                                        // ### Check BackOrder
                                        if (value <= record.quantity_backorder) {
                                            // ### SUM of All Begran should be Less Than Backorder
                                            if (sum_of_bergans <= record.quantity_backorder) {
                                                v.input_bergen_ws_qty = value;
                                            } else {
                                                Swal.fire({
                                                    icon: "error",
                                                    title: `OOPS`,
                                                    text: `Your Total BackOrder is = ${record.quantity_backorder} and Your Bergan Sum is ${sum_of_bergans}, should not be Greater Than ${record.quantity_backorder}`,
                                                })
                                            }
                                        } else {
                                            Swal.fire({
                                                icon: "error",
                                                title: `OOPS`,
                                                text: "Bergan WS QTY Should not be Greater Than QTY BackOrder",
                                            })
                                        }
                                    } else {
                                        v.input_bergen_ws_qty = 0;
                                        Swal.fire({
                                            icon: "error",
                                            title: `OOPS`,
                                            text: "Bergan WS QTY Should be Less Than Exact Bergan WS QTY",
                                        })
                                    }
                                }
                                return v;
                            });
                            setOrderItems(filterItem);
                        }}
                    />
                </>;
            },
        },
        {
            title: "Bergen Ecom",
            dataIndex: "bergen_ecom_qty",
            width: 80,
            editable: true,
            render: (text, record, index) => {
                return <>
                    <Input
                        // value={0}
                        value={record.input_bergen_ecom_qty || 0}
                        type="number"
                        onChange={(e) => {
                            let value = Number(e.target.value);
                            let copyArr = [...orderItems];
                            // ### SUM of All 4 Bergan Values
                            let sum_of_bergans = value + Number(record.input_bergen_nord_qty || 0) + Number(record.input_bergen_saks_qty || 0) + Number(record.input_bergen_ws_qty || 0);
                            let filterItem = copyArr.filter((v) => {
                                if (v.order_lines_id === record.order_lines_id) {
                                    if (value < 0) {
                                        Swal.fire({
                                            icon: "error",
                                            title: `OOPS`,
                                            text: "Bergan Ecom QTY can't be Negative",
                                        })
                                    } else if (value <= record.bergen_ecom_qty) {
                                        // ### Check BackOrder
                                        if (value <= record.quantity_backorder) {
                                            // ### SUM of All Begran should be Less Than Backorder
                                            if (sum_of_bergans <= record.quantity_backorder) {
                                                v.input_bergen_ecom_qty = value;
                                            } else {
                                                Swal.fire({
                                                    icon: "error",
                                                    title: `OOPS`,
                                                    text: `Your Total BackOrder is = ${record.quantity_backorder} and Your Bergan Sum is ${sum_of_bergans}, should not be Greater Than ${record.quantity_backorder}`,
                                                })
                                            }
                                        } else {
                                            Swal.fire({
                                                icon: "error",
                                                title: `OOPS`,
                                                text: "Bergan Ecom QTY Should not be Greater Than QTY BackOrder",
                                            })
                                        }
                                    } else {
                                        v.input_bergen_ecom_qty = 0;
                                        Swal.fire({
                                            icon: "error",
                                            title: `OOPS`,
                                            text: "Bergan Ecom QTY Should be Less Than Exact Bergan Ecom QTY",
                                        })
                                    }
                                }
                                return v;
                            });
                            setOrderItems(filterItem);
                        }}
                    />
                </>;
            },
        },
        {
            title: "Bergen Nord",
            dataIndex: "bergen_nord_qty",
            width: 80,
            editable: true,
            render: (text, record, index) => {
                return <>
                    <Input
                        value={record.input_bergen_nord_qty || 0}
                        type="number"
                        onChange={(e) => {
                            let value = Number(e.target.value);
                            let copyArr = [...orderItems];
                            let sum_of_bergans = value + Number(record.input_bergen_ecom_qty || 0) + Number(record.input_bergen_saks_qty || 0) + Number(record.input_bergen_ws_qty || 0);
                            let filterItem = copyArr.filter((v) => {
                                if (v.order_lines_id === record.order_lines_id) {
                                    if (value < 0) {
                                        Swal.fire({
                                            icon: "error",
                                            title: `OOPS`,
                                            text: "Bergan Nord QTY can't be Negative",
                                        })
                                    } else if (value <= record.bergen_nord_qty) {
                                        // ### Check BackOrder
                                        if (value <= record.quantity_backorder) {
                                            // ### SUM of All Begran should be Less Than Backorder
                                            if (sum_of_bergans <= record.quantity_backorder) {
                                                v.input_bergen_nord_qty = value;
                                            } else {
                                                Swal.fire({
                                                    icon: "error",
                                                    title: `OOPS`,
                                                    text: `Your Total BackOrder is = ${record.quantity_backorder} and Your Bergan Sum is ${sum_of_bergans}, should not be Greater Than ${record.quantity_backorder}`,
                                                })
                                            }
                                        } else {
                                            Swal.fire({
                                                icon: "error",
                                                title: `OOPS`,
                                                text: "Bergan Nord QTY Should not be Greater Than QTY BackOrder",
                                            })
                                        }
                                    } else {
                                        v.input_bergen_nord_qty = 0;
                                        Swal.fire({
                                            icon: "error",
                                            title: `OOPS`,
                                            text: "Bergan Nord QTY Should be Less Than Exact Bergan Nord QTY",
                                        })
                                    }
                                }
                                return v;
                            });
                            setOrderItems(filterItem);
                        }}
                    />
                </>;
            },
        },
        {
            title: "Bergen Saks",
            dataIndex: "bergen_saks_qty",
            width: 80,
            editable: true,
            render: (text, record, index) => {
                return <>
                    <Input
                        // value={0}
                        value={record.input_bergen_saks_qty || 0}
                        type="number"
                        onChange={(e) => {
                            let value = Number(e.target.value);
                            let copyArr = [...orderItems];
                            let sum_of_bergans = value + Number(record.input_bergen_ecom_qty || 0) + Number(record.input_bergen_nord_qty || 0) + Number(record.input_bergen_ws_qty || 0);
                            let filterItem = copyArr.filter((v) => {
                                if (v.order_lines_id === record.order_lines_id) {
                                    if (value < 0) {
                                        Swal.fire({
                                            icon: "error",
                                            title: `OOPS`,
                                            text: "Bergan Saks QTY can't be Negative",
                                        })
                                    } else if (value <= record.bergen_saks_qty) {
                                        // ### Check BackOrder
                                        if (value <= record.quantity_backorder) {
                                            // ### SUM of All Begran should be Less Than Backorder
                                            if (sum_of_bergans <= record.quantity_backorder) {
                                                v.input_bergen_saks_qty = value;
                                            } else {
                                                Swal.fire({
                                                    icon: "error",
                                                    title: `OOPS`,
                                                    text: `Your Total BackOrder is = ${record.quantity_backorder} and Your Bergan Sum is ${sum_of_bergans}, should not be Greater Than ${record.quantity_backorder}`,
                                                })
                                            }
                                        } else {
                                            Swal.fire({
                                                icon: "error",
                                                title: `OOPS`,
                                                text: "Bergan Saks QTY Should not be Greater Than QTY BackOrder",
                                            })
                                        }
                                    } else {
                                        v.input_bergen_saks_qty = 0;
                                        Swal.fire({
                                            icon: "error",
                                            title: `OOPS`,
                                            text: "Bergan Saks QTY Should be Less Than Exact Bergan Saks QTY",
                                        })
                                    }
                                }
                                return v;
                            });
                            setOrderItems(filterItem);
                        }}
                    />
                </>;
            },
        },
    ];

    const onFinish = async () => {
        setLoading(true);
        await form.validateFields().then((values) => {
            dispatch(getCCOrderProcessing(token, values)).then((res) => {
                setLoading(false);
                setOrderProcessingList(res?.payload?.data);
                downloadExcelFileData(res?.payload?.data);
            });
        }).catch((error) => {
            setLoading(false);
        })
    }

    const totalQuantity = () => {
        let sumQty = orderProcessingList.reduce(function (previousValue, currentValue) {
            return previousValue += Number(currentValue.pendingqty);
        }, 0);
        return sumQty;
    }

    const totalSum = () => {
        let sumAmount = orderProcessingList.reduce(function (previousValue, currentValue) {
            return previousValue += Number(currentValue.amount);
        }, 0);
        return sumAmount;
    }

    const showModal = () => {
        setIsModalOpen(true);
    };

    const handleOk = () => {
        const groupedData = {
            user_name: userName,
            bergen_ecom_qty: [],
            bergen_nord_qty: [],
            bergen_saks_qty: [],
            bergen_ws_qty: []
        };
        orderItems.forEach(item => {
            if (item.input_bergen_ecom_qty > 0) groupedData.bergen_ecom_qty.push(item);
            if (item.input_bergen_nord_qty > 0) groupedData.bergen_nord_qty.push(item);
            if (item.input_bergen_saks_qty > 0) groupedData.bergen_saks_qty.push(item);
            if (item.input_bergen_ws_qty > 0) groupedData.bergen_ws_qty.push(item);
        });
        if (groupedData.bergen_ecom_qty.length > 0 || groupedData.bergen_nord_qty.length > 0 || groupedData.bergen_saks_qty.length > 0 || groupedData.bergen_ws_qty.length > 0) {
            dispatch(createCCOrderProcessing(token, groupedData)).then((res) => {
                if (res.type === "CREATE_CC_ORDER_PROCESSING_SUCCESS") {
                    Swal.fire({
                        icon: "success",
                        title: `SuccessFully`,
                        text: `${res.payload.data}`
                    });
                    setIsModalOpen(false);
                } else if (res.type === "CREATE_CC_ORDER_PROCESSING_ERROR") {
                    Swal.fire({
                        icon: "error",
                        title: `OOPS`,
                        text: `${res.payload.data}`
                    })
                }
            })
        } else {
            Swal.fire({
                icon: "error",
                title: `OOPS`,
                text: `Input Values should not be 0`
            })
        }
    };

    const backOrderZeroGreater = orderItems.filter((item) => item.quantity_backorder > 0) || [];

    return (
        <div className="styleContainer">
            <div className="styleBody h-100">
                <PageHeader
                    title={"CC Order Processing"}
                    minimize={setMinimize}
                    check={minimize}
                />
                {!minimize && (
                    <div className="bodyStyle">
                        <div className="formProduct p-0">
                            <Form onFinish={onFinish} form={form} name="control-hooks">
                                <div className="container-fluid pbpx-5 ptpx-5">
                                    <Brow>
                                        <Bcol lg={6} xl={4} xxl={3}>
                                            <div >
                                                <div className="relative">
                                                    <Form.Item
                                                        name="to_date"
                                                        label="To Date:"
                                                        labelAlign="left"
                                                        labelCol={{ span: 8 }}
                                                        wrapperCol={{ span: 16 }}
                                                        initialValue={moment().endOf('year')}
                                                    >
                                                        <DatePicker
                                                            size='small'
                                                            className="styleInput w-100"
                                                            format={"MM-DD-YYYY"}
                                                            defaultValue={moment().format("MM-DD-YYYY")}
                                                        />
                                                    </Form.Item>
                                                </div>
                                            </div>
                                        </Bcol>
                                        <Bcol lg={6} xl={4} xxl={3}>
                                            <div className="">
                                                <div >
                                                    <Form.Item
                                                        name="order_no"
                                                        label="Order #"
                                                        labelAlign="left"
                                                        labelCol={{ span: 8 }}
                                                        wrapperCol={{ span: 16 }}
                                                    >
                                                        <InputNumber
                                                            size='small'
                                                            className="styleInput"
                                                        />
                                                    </Form.Item>
                                                </div>
                                            </div>
                                        </Bcol>
                                        <Bcol lg={6} xl={4} xxl={3}>
                                            <div className="">
                                                <div >
                                                    <Form.Item
                                                        name="customer"
                                                        label="Customer"
                                                        labelAlign="left"
                                                        labelCol={{ span: 8 }}
                                                        wrapperCol={{ span: 16 }}
                                                    >
                                                        <Input
                                                            size='small'
                                                            className="styleInput"
                                                        />
                                                    </Form.Item>
                                                </div>
                                            </div>
                                        </Bcol>
                                        <Bcol lg={6} xl={4} xxl={3}>
                                            <div className="">
                                                <div >
                                                    <Form.Item
                                                        name="po_no"
                                                        label="PO #"
                                                        labelAlign="left"
                                                        labelCol={{ span: 8 }}
                                                        wrapperCol={{ span: 16 }}
                                                    >
                                                        <Input
                                                            size='small'
                                                            className="styleInput"
                                                        />
                                                    </Form.Item>
                                                </div>
                                            </div>
                                        </Bcol>
                                        <Bcol lg={6} xl={4} xxl={3}>
                                            <div className="slc">
                                                <Form.Item
                                                    name="sale_person"
                                                    label="Sale Person"
                                                    labelAlign="left"
                                                    labelCol={{ span: 8 }}
                                                    wrapperCol={{ span: 16 }}
                                                    initialValue={"All"}
                                                >
                                                    <Select
                                                        size='small'
                                                        showSearch
                                                        optionFilterProp="children"
                                                        filterSort={(optionA, optionB) =>
                                                            optionB?.value !== null ?
                                                                optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase()) : ''
                                                        }
                                                        className="styleInput w-100"
                                                        defaultValue={form.getFieldValue().sale_person}
                                                    >
                                                        <Option value={null}>All</Option>
                                                        {
                                                            salePersonForm?.payload?.data.map((val, index) => {
                                                                return (
                                                                    <Option key={index} value={val.sales_person_id}>{val.salesperson_name}</Option>
                                                                )
                                                            })
                                                        }
                                                    </Select>
                                                </Form.Item>
                                            </div>
                                        </Bcol>
                                        <Bcol lg={6} xl={4} xxl={3}>
                                            <div className="slc">
                                                <Form.Item
                                                    name="region"
                                                    label="Region"
                                                    labelAlign="left"
                                                    labelCol={{ span: 8 }}
                                                    wrapperCol={{ span: 16 }}
                                                    initialValue={"All"}
                                                >
                                                    <Select
                                                        size='small'
                                                        showSearch
                                                        optionFilterProp="children"
                                                        filterSort={(optionA, optionB) =>
                                                            optionB?.value !== null ?
                                                                optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase()) : ''
                                                        }
                                                        className="styleInput w-100"
                                                        defaultValue={form.getFieldValue().region}
                                                    >
                                                        <Option value={null}>All</Option>
                                                        {
                                                            region?.payload?.data.map((val) => {
                                                                return (
                                                                    <Option key={val.region_id} value={val.region_id}>{val.region_name}</Option>
                                                                )
                                                            })
                                                        }
                                                    </Select>
                                                </Form.Item>
                                            </div>
                                        </Bcol>
                                        <Bcol lg={6} xl={4} xxl={3}>
                                            <div className="slc">
                                                <Form.Item
                                                    name="gender"
                                                    label="Gender"
                                                    labelAlign="left"
                                                    labelCol={{ span: 8 }}
                                                    wrapperCol={{ span: 16 }}
                                                    initialValue={"All"}
                                                >
                                                    <Select
                                                        size='small'
                                                        showSearch
                                                        optionFilterProp="children"
                                                        filterOption={(input, options) =>
                                                            options.children.toLowerCase().indexOf(input.toLowerCase()) >=
                                                            0
                                                        }
                                                        className="styleInput w-100"
                                                        defaultValue={form.getFieldValue().gender}
                                                    >
                                                        <Option value={null}>All</Option>
                                                        {
                                                            gender?.payload?.data.map((val) => {
                                                                return (
                                                                    <Option key={val.gender_id} value={val.gender_id}>{val.gender_name}</Option>
                                                                )
                                                            })
                                                        }
                                                    </Select>
                                                </Form.Item>
                                            </div>
                                        </Bcol>
                                        <Bcol lg={6} xl={4} xxl={3}>
                                            <div className="slc">
                                                <Form.Item
                                                    name="terms"
                                                    label="Terms"
                                                    labelAlign="left"
                                                    labelCol={{ span: 8 }}
                                                    wrapperCol={{ span: 16 }}
                                                    initialValue={"All"}
                                                >
                                                    <Select
                                                        size='small'
                                                        showSearch
                                                        optionFilterProp="children"
                                                        filterSort={(optionA, optionB) =>
                                                            optionB?.value !== null ?
                                                                optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase()) : ''
                                                        }
                                                        className="styleInput w-100"
                                                        defaultValue={form.getFieldValue().terms}
                                                    >
                                                        <Option value={null}>All</Option>
                                                        {
                                                            paymentterm?.payload?.data.map((val) => {
                                                                return (
                                                                    <Option key={val.term_id} value={val.term_id}>{val.term_name}</Option>
                                                                )
                                                            })
                                                        }
                                                    </Select>
                                                </Form.Item>
                                            </div>
                                        </Bcol>
                                        <Bcol lg={6} xl={4} xxl={3}>
                                            <div className="slc">
                                                <Form.Item
                                                    name="source"
                                                    label="Source"
                                                    labelAlign="left"
                                                    labelCol={{ span: 8 }}
                                                    wrapperCol={{ span: 16 }}
                                                >
                                                    <Input
                                                        size='small'
                                                        className="styleInput"
                                                    />
                                                </Form.Item>
                                            </div>
                                        </Bcol>
                                    </Brow>
                                </div>
                            </Form>
                            <Button
                                htmlType="submit"
                                type="primary"
                                className="submit-btn-btm "
                                onClick={onFinish}
                            >
                                Submit
                            </Button>
                        </div>
                    </div>
                )}
            </div>
            <div style={{ marginTop: 10 }}>
                {
                    loading ? (
                        <div className=" report-wrapper-main d-flex align-items-center justify-content-center spin-style mt-3">
                            <Spin size='large' />
                        </div>
                    ) : (
                        orderProcessingList.length > 0 ? (
                            <Table
                                title={() =>
                                    <CSVLink
                                        filename={"Create PT.csv"}
                                        data={excelData}
                                        onClick={() => {
                                        }}
                                    >
                                        Download Excel
                                    </CSVLink>
                                }
                                ref={tableRef}
                                size="small"
                                bordered={false}
                                type="company"
                                scroll={{
                                    x: 'calc(700px + 90%)',
                                    y: 450,
                                }}
                                summary={(pageData) => {
                                    let sumQty = pageData.reduce(function (
                                        previousValue,
                                        currentValue
                                    ) {
                                        return (previousValue += parseFloat(
                                            currentValue.totalqty
                                        ));
                                    },
                                        0);
                                    let PendingQty = pageData.reduce(function (
                                        previousValue,
                                        currentValue
                                    ) {
                                        return (previousValue += parseFloat(
                                            currentValue.pendingqty
                                        ));
                                    },
                                        0);
                                    let AccCommited = pageData.reduce(function (
                                        previousValue,
                                        currentValue
                                    ) {
                                        return (previousValue += parseFloat(
                                            currentValue.quantity_committed
                                        ));
                                    },
                                        0);
                                    let Backorder = pageData.reduce(function (
                                        previousValue,
                                        currentValue
                                    ) {
                                        return (previousValue += parseFloat(
                                            currentValue.quantity_backorder
                                        ));
                                    },
                                        0);
                                    let Amount = pageData.reduce(function (
                                        previousValue,
                                        currentValue
                                    ) {
                                        return (previousValue += parseFloat(
                                            currentValue.amount
                                        ));
                                    },
                                        0);
                                    return (
                                        <>
                                            <Table.Summary.Row>
                                                <Table.Summary.Cell colSpan={3}>Total Quantity : {numeral(totalQuantity()).format("0,00,0")}
                                                </Table.Summary.Cell>
                                                <Table.Summary.Cell></Table.Summary.Cell>
                                                <Table.Summary.Cell></Table.Summary.Cell>
                                                <Table.Summary.Cell></Table.Summary.Cell>
                                                <Table.Summary.Cell></Table.Summary.Cell>
                                                <Table.Summary.Cell></Table.Summary.Cell>
                                                <Table.Summary.Cell>
                                                    <p style={{ textAlign: "right" }} className="totalquantity">
                                                        {sumQty.toLocaleString("en-US")}
                                                    </p>
                                                </Table.Summary.Cell>
                                                <Table.Summary.Cell>
                                                    <p style={{ textAlign: "right" }} className="totalquantity">
                                                        {PendingQty.toLocaleString("en-US")}
                                                    </p>
                                                </Table.Summary.Cell>
                                                <Table.Summary.Cell>
                                                    <p style={{ textAlign: "right" }} className="totalquantity">
                                                        {AccCommited.toLocaleString("en-US")}
                                                    </p>
                                                </Table.Summary.Cell>
                                                <Table.Summary.Cell>
                                                    <p style={{ textAlign: "right" }} className="totalquantity">
                                                        {Backorder.toLocaleString("en-US")}
                                                    </p>
                                                </Table.Summary.Cell>
                                                <Table.Summary.Cell>
                                                    <p style={{ textAlign: "right" }} className="totalquantity">
                                                        {currencySymbol} {Amount.toLocaleString("en-US")}
                                                    </p>
                                                </Table.Summary.Cell>
                                            </Table.Summary.Row>
                                            <Table.Summary.Row>
                                                <Table.Summary.Cell colSpan={3} style={{ paddingTop: "10px", fontWeight: "bolder" }}>Total Amount : {currencySymbol}{numeral(totalSum()).format("0,0.00")}
                                                </Table.Summary.Cell>
                                            </Table.Summary.Row>
                                        </>
                                    );
                                }}
                                dataSource={orderProcessingList}
                                columns={columns}
                                loading={ccOrderProcessing.loading}
                                pagination={{
                                    defaultCurrent: 1,
                                    defaultPageSize: 100,
                                    pageSizeOptions: [100, 500, 1000, 2000, 2500, 3000]
                                }}
                            />
                        ) : <div
                            style={{
                                backgroundColor: "#CCCCCC",
                                borderWidth: "1pt",
                                borderStyle: "Dashed",
                                fontWeight: "bold",
                                height: "25px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                            }}
                        >
                            No record(s)
                        </div>
                    )
                }
                <Modal
                    width={"90%"}
                    title={
                        "Details"
                    }
                    visible={isModalOpen}
                    onOk={handleOk}
                    confirmLoading={ccOrderProcessing?.loading}
                    okText={"Transfer"}
                    onCancel={() => setIsModalOpen(false)}
                >
                    <Table
                        ref={tableRef}
                        size="small"
                        bordered={false}
                        type="company"
                        dataSource={backOrderZeroGreater || []}
                        columns={SOColumns2}
                        loading={saleOrderLine.loading}
                        pagination={{
                            defaultCurrent: 1,
                            defaultPageSize: 100,
                            pageSizeOptions: [100, 500, 1000, 2000, 2500, 3000]
                        }}
                    />
                </Modal>
            </div>
        </div>
    )
}

export default CCOrderProcessing;

